import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Video, ShieldAlert } from "lucide-react";

export default function VideoPlayer({ assetId, testId = "video-player", showWatermarkForEditor = true }) {
  const { isAdmin } = useAuth();
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let objectUrl;
    setLoading(true);
    setError(null);
    if (!assetId) { setLoading(false); return; }
    api.get(`/assets/${assetId}/content`, { responseType: "blob" })
      .then((res) => { objectUrl = URL.createObjectURL(res.data); setUrl(objectUrl); })
      .catch(() => setError("Preview unavailable"))
      .finally(() => setLoading(false));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [assetId]);

  if (loading)
    return (
      <div data-testid={`${testId}-loading`} className="flex h-full w-full items-center justify-center bg-[#0a0a0a]">
        <Loader2 className="h-8 w-8 animate-spin text-[#00E5FF]" />
      </div>
    );
  if (error || !url)
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-2 bg-[#0a0a0a] text-gray-500">
        <Video className="h-8 w-8" />
        <span className="text-sm">{error || "No preview"}</span>
      </div>
    );

  return (
    <div className="relative h-full w-full" data-testid={testId}>
      <video src={url} controls className="h-full w-full bg-black object-contain" data-testid={`${testId}-el`} />
      {!isAdmin && showWatermarkForEditor && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
          <div className="rotate-[-25deg] select-none whitespace-nowrap text-5xl font-black uppercase tracking-widest text-white/10">
            ReelForge · Preview · ReelForge · Preview
          </div>
          <div className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded bg-black/60 px-2 py-1 text-[10px] font-semibold text-[#FF007F]">
            <ShieldAlert className="h-3 w-3" /> WATERMARKED PREVIEW
          </div>
        </div>
      )}
    </div>
  );
}
